import { FillLayer } from "react-map-gl";
import { Theme } from "@mui/material/styles";

type MapLayers = {
  base: FillLayer;
  hover: FillLayer;
  select: FillLayer;
}

export const getAreaLayers = (theme:Theme): MapLayers => {
  return {
    base: {
      id: "area-base",
      type: "fill",
      "source-layer": "postal_area_test",
      maxzoom: 7,
      minzoom: 4,
      paint: {
        "fill-outline-color": "rgba(33,43,58,0.4)",
        "fill-color": [
          "case",
          ["==", ["feature-state", "score"], null],
          "#ECF3F4",
          [
            "interpolate",
            ["linear"],
            ["feature-state", "score"],
            0,
            theme.palette.gradient[0],
            0.1,
            theme.palette.gradient[1],
            0.2,
            theme.palette.gradient[2],
            0.3,
            theme.palette.gradient[3],
            0.4,
            theme.palette.gradient[4],
          ],
        ],
        "fill-opacity": [
          "case",
          ["==", ["feature-state", "score"], null],
          0,
          ["case", ["<", ["feature-state", "score"], 0], 0, 1],
        ],
      },
    },
    hover: {
      id: "area-hover",
      type: "fill",
      "source-layer": "postal_area_test",
      maxzoom: 7,
      minzoom: 4,
      paint: {
        // "fill-outline-color": "#FFFFFF",
        "fill-color": "#FFFFFF",
        "fill-opacity": 0.3,
      },
    },
    select: {
      id: "area-select",
      type: "fill",
      "source-layer": "postal_area_test",
      maxzoom: 7,
      minzoom: 4,
      paint: {
        // "fill-outline-color": "#F5B49F",
        "fill-color": "#F5B49F",
        "fill-opacity": 1.0,
      },
    }
  }
}

export const getDistrictLayers = (theme:Theme): MapLayers => {
  return {
    base: {
      id: "district-base",
      type: "fill",
      "source-layer": "postal_district_test",
      maxzoom: 9,
      minzoom: 7,
      paint: {
        "fill-outline-color": "rgba(33,43,58,0.4)",
        "fill-color": [
          "interpolate",
          ["linear"],
          ["feature-state", "score"],
          // 0, '#212b3a',
          0,
          theme.palette.gradient[0],
          0.1,
          theme.palette.gradient[1],
          0.2,
          theme.palette.gradient[2],
          0.4,
          theme.palette.gradient[3],
          0.6,
          theme.palette.gradient[4],
        ],
        "fill-opacity": [
          "case",
          ["==", ["feature-state", "score"], null],
          0,
          ["case", ["<", ["feature-state", "score"], 0], 0, 1],
        ],
      },
    },
    hover: {
      id: "district-hover",
      type: "fill",
      "source-layer": "postal_district_test",
      maxzoom: 9,
      minzoom: 7,
      paint: {
        // "fill-outline-color": "#FFFFFF",
        "fill-color": "#FFFFFF",
        "fill-opacity": 0.3,
      },
    },
    select: {
      id: "district-select",
      type: "fill",
      "source-layer": "postal_district_test",
      maxzoom: 9,
      minzoom: 7,
      paint: {
        // "fill-outline-color": "#F5B49F",
        "fill-color": "#F5B49F",
        "fill-opacity": 1.0,
      },
    }
  }
}

export const getSectorLayers = (theme:Theme): MapLayers => {
  return {
    base: {
      id: "sector-base",
      type: "fill",
      "source-layer": "postal_sector_test",
      minzoom: 9,
      paint: {
        "fill-outline-color": "rgba(33,43,58,0.4)",
        "fill-color": [
          "interpolate",
          ["linear"],
          ["feature-state", "score"],
          0,
          theme.palette.gradient[0],
          0.2,
          theme.palette.gradient[1],
          0.4,
          theme.palette.gradient[2],
          0.6,
          theme.palette.gradient[3],
          0.8,
          theme.palette.gradient[4],
        ],
        "fill-opacity": [
          "case",
          ["==", ["feature-state", "score"], null],
          0,
          ["case", ["<", ["feature-state", "score"], 0], 0, 1],
        ],
      },
    },
    hover: {
      id: "sector-hover",
      type: "fill",
      "source-layer": "postal_sector_test",
      minzoom: 9,
      paint: {
        // "fill-outline-color": "#FFFFFF",
        "fill-color": "#FFFFFF",
        "fill-opacity": 0.3,
      },
    },
    select: {
      id: "sector-select",
      type: "fill",
      "source-layer": "postal_sector_test",
      minzoom: 9,
      paint: {
        // "fill-outline-color": "#F5B49F",
        "fill-color": "#F5B49F",
        "fill-opacity": 1.0,
      },
    }
  }
}

